import React from "react";
import usePrintWaybillClick from "./hooks/usePrintWaybillClick";
import OrderTab from "../../enum/OrderTab";
import ShopDTO from "@/dto/shop/ShopDTO";
import { useGlobalStore, useShippingAreaStore } from "@/store/hooks";
import { observer } from "mobx-react-lite";
import { useOrderManagementStore } from "../../store/OrderManagementStore";
import AutoLoadingButton from "@/components/AutoLoadingButton";
import { buildSingleShopOrderOriginCheckFunc } from "@/utils/ShopUtils";

interface PrintWaybillButtonProps {
    tab: OrderTab;

    shop: ShopDTO;
}

const PrintWaybillButton: React.FC<PrintWaybillButtonProps> = function (props) {
    const { tab, shop } = props;
    const orderManagementStore = useOrderManagementStore();
    const { shippingAreaMap } = useShippingAreaStore();
    const globalStore = useGlobalStore();

    const refresh = () => {
        orderManagementStore.fetchOrders(shop.id, tab);
    };

    function onShipTaskDone() {
        orderManagementStore.fetchOrders(shop.id, tab);
        orderManagementStore.getOrderListCount();
    }

    const { handlePrint } = usePrintWaybillClick({
        getSelectedOrders: orderManagementStore.table.getSelectedOrders,
        onShipTaskDone: onShipTaskDone,
        onUpdateOrder(id, params) {
            orderManagementStore.table.updateOrder(id, params);
        },
        multiPlatformModalOrderOriginCheck: buildSingleShopOrderOriginCheckFunc(
            shop,
            orderManagementStore.supplierPartnershipsStore,
        ),
        onRefreshOrders: refresh,
        onUpdateOrderSellerRemarks: orderManagementStore.table.updateSellerRemarks,
        onUpdateSupplierOrderRemarks: orderManagementStore.table.updateSupplierOrderRemarks,
        supplierPartnershipsStore: orderManagementStore.supplierPartnershipsStore,
    });

    return (
        <AutoLoadingButton
            type="primary"
            className="ec-print-waybill-button mr3"
            onClick={async () => {
                const { shippingAreaId, templateId } = orderManagementStore.table.form?.getFieldsValue() || {};
                const shippingArea = shippingAreaMap.get(Number(shippingAreaId));

                let defaultTemplateId = shippingArea?.bindingWaybillTemplate;

                if (templateId) {
                    await globalStore.waybillPrintStore.ensureWaybillTemplates();
                    const waybillTemplate = globalStore.waybillPrintStore.waybillTemplates?.find(
                        ({ id }) => id === templateId,
                    );

                    if (waybillTemplate) {
                        defaultTemplateId = waybillTemplate.id;
                    }
                }

                await handlePrint(defaultTemplateId);
            }}
        >
            打印快递单
        </AutoLoadingButton>
    );
};

export default observer(PrintWaybillButton);
